(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .service('TechElementModuleService', TechElementModuleService);

  TechElementModuleService.$inject = ['Labels', 'SimpleDialogFormService', 'Constants', 'TechnicalElementsAPI'];

  function TechElementModuleService (Labels, SimpleDialogFormService, Constants, TechnicalElementsAPI) {

    let optionvalues = [];
    let options = {};

    Constants.getConstants().then(function (constants) {
      optionvalues = constants.REQUIREMENT_TYPES.map(function (requirementtype) {
        return {value: requirementtype.value, displayName: requirementtype.displayPlural};
      });
      init();
    });

    return {
      open: openModal,
      confirmDelete: confirmDelete
    };

    // ////////////

    function init () {
      options = {
        title: Labels.getLabel('editmodule'),

        fields: [
          {
            key: 'name',
            label: Labels.getLabel('modulename'),
            required: true,
            type: 'text'
          },
          {
            key: 'protected',
            label: Labels.getLabel('protected'),
            required: false,
            type: 'checkbox'
          },
          {
            key: 'viewtab',
            label: Labels.getLabel('areasheetcategory'),
            required: true,
            type: 'select',
            optionvalues: optionvalues
          },
        ],

        save: function (form, instance) {
          form.active = true;
          if (instance && instance._id) {
            return TechnicalElementsAPI.updateModule({module: form, id: instance._id}).$promise;
          }

          return TechnicalElementsAPI.createModule({module: form}).$promise;
        }
      };
    }

    function openModal (ev, instance) {
      return SimpleDialogFormService.open(ev, options, instance);
    }

    function confirmDelete (ev, instance) {
      let options = {
        title: Labels.getLabel('deletemoduletitle'),
        content: Labels.getLabel('areyousuredeletemodule'),
        warning: Labels.getLabel('thisactioncannotbeundone'),
        ok: Labels.getLabel('delete'),
        ok_icon: 'delete',
        cancel: Labels.getLabel('cancel')
      };
      return SimpleDialogFormService.confirm(ev, options, instance).then(() => removeTechModule(instance));
    }

    function removeTechModule (techModule) {
      techModule.active = false;
      const updatedModule = {id: techModule._id, module: techModule};
      return TechnicalElementsAPI.updateModule(updatedModule).$promise;
    }

  }
})();
